import { render, staticRenderFns } from "./BaseShareButton.vue?vue&type=template&id=6f98dd6b"
import script from "./BaseShareButton.vue?vue&type=script&lang=js"
export * from "./BaseShareButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports